export const SERVICE_PAGES = {
  auto: {
    slug: "auto",
    title: "Auto Insurance",
    eyebrow: "Coverage on the road",
    banner: "https://static.wixstatic.com/media/5cda707e579f481091fc99762b5b521e.jpg/v1/fill/w_1905,h_460,al_c,q_85,enc_avif,quality_auto/5cda707e579f481091fc99762b5b521e.jpg",
    hero_image: "https://static.wixstatic.com/media/7a755a_d8323c3e733a48699a18a40b1e81f14b~mv2.jpg/v1/fill/w_857,h_686,al_c,q_85,enc_avif,quality_auto/7a755a_d8323c3e733a48699a18a40b1e81f14b~mv2.jpg",
    intro:
      "Protect yourself and your family on the road with our affordable and comprehensive auto insurance plans. Our agents are here to guide you through your options and provide personalized quotes.",
    coverage_heading:
      "In addition to the basic coverage required by law, we offer policies that include coverage for other incidentals, such as:",
    coverage: [
      "Collision Damage",
      "Comprehensive Damage",
      "Medical",
      "Uninsured Motorist",
      "Rental Reimbursement",
      "Roadside Assistance",
    ],
    discounts_heading:
      "We're happy to be able to offer our customers several policy discounts, for example:",
    discounts: [
      "Good-Driver Discount",
      "Multi-Policy Discount",
      "Good Student Discount",
      "Mature Driver Discount",
    ],
  },
  home: {
    slug: "home",
    title: "Homeowners Insurance",
    eyebrow: "Protecting your home",
    banner: "https://static.wixstatic.com/media/11062b_dc6171c8c77e481e8a6905e00a4a3583~mv2_d_2917_1843_s_2.jpg/v1/fill/w_1905,h_460,al_c,q_85,enc_avif,quality_auto/11062b_dc6171c8c77e481e8a6905e00a4a3583~mv2_d_2917_1843_s_2.jpg",
    hero_image: "https://static.wixstatic.com/media/7a755a_607a684488444854987a74e884a6f38a~mv2.jpg/v1/fill/w_857,h_762,al_c,q_85,enc_avif,quality_auto/7a755a_607a684488444854987a74e884a6f38a~mv2.jpg",
    intro:
      "Your home insurance should be as unique as your home, which is why we provide a range of policy options. Whether you have specific needs or a set budget, we have a plan that's right for you. A standard policy includes property and liability coverage, but there are numerous ways to customize it to suit your preferences.",
    coverage_heading:
      "Here are some of the additional coverage options Knight Insurance Solutions can offer you:",
    coverage: [
      "Guaranteed Home Replacement",
      "Personal Property Replacement",
      "Sewer Damage Protection",
      "Earthquake Protection",
      "Personal Injury Protection",
    ],
    discounts_heading:
      "We're proud to offer our customers some fantastic discounts with their home insurance policy. These include:",
    discounts: [
      "Multi-Policy Discount",
      "Protective Devices",
      "Premises Alarms",
      "Deductible Credit",
    ],
  },
  life: {
    slug: "life",
    title: "Life Insurance",
    eyebrow: "For the people who matter most",
    banner: "https://static.wixstatic.com/media/93507cc36ceb4f698334c53a1c91e168.jpg/v1/fill/w_1905,h_460,al_c,q_85,enc_avif,quality_auto/93507cc36ceb4f698334c53a1c91e168.jpg",
    hero_image: "https://static.wixstatic.com/media/11062b_abbe61e99e644bc9b6bc367d1cd4da36~mv2.jpg/v1/fill/w_857,h_681,al_c,q_85,enc_avif,quality_auto/11062b_abbe61e99e644bc9b6bc367d1cd4da36~mv2.jpg",
    intro:
      "Life insurance isn't one-size-fits-all. Knight Insurance Solutions's experienced insurance agents will get to know you and your family to set you up with coverage that serves your unique needs.",
    coverage_heading: "Some of the life insurance options we offer are:",
    coverage: [
      "Whole and Universal Life Insurance",
      "Term Life Insurance",
      "Children's Life Insurance",
      "Mortgage Protection Insurance",
      "Annuities",
      "Final Expense",
    ],
  },
  health: {
    slug: "health",
    title: "Health Insurance",
    eyebrow: "Care, simplified",
    banner: "https://static.wixstatic.com/media/93507cc36ceb4f698334c53a1c91e168.jpg/v1/fill/w_1905,h_460,al_c,q_85,enc_avif,quality_auto/93507cc36ceb4f698334c53a1c91e168.jpg",
    hero_image: "https://static.wixstatic.com/media/7a755a_da21c3c2ed104520b3348849bd0e444f~mv2.jpg/v1/fill/w_745,h_699,al_c,q_85,enc_avif,quality_auto/7a755a_da21c3c2ed104520b3348849bd0e444f~mv2.jpg",
    intro:
      "Knight Insurance Solutions is focused on assisting clients in navigating the ever-evolving and often complicated world of health insurance. By leveraging our expertise in health insurance and our deep commitment to helping others, we advocate for our clients to ensure their unique needs and preferences are fully addressed.",
    coverage_heading:
      "In addition to the basic coverage required by law, we offer policies that include coverage for other incidentals, such as:",
    coverage: [
      "Medical insurance for entrepreneurs and individuals",
      "Medicare and Medicaid",
      "Dental",
      "Vision",
      "Short-term disability and Long-term disability",
      "Accidental death and dismemberment",
      "Long term care",
      "Supplemental benefits",
      "Group health plans and more…",
    ],
  },
  business: {
    slug: "business",
    title: "Business Insurance",
    eyebrow: "Protecting what you've built",
    banner: "https://static.wixstatic.com/media/93507cc36ceb4f698334c53a1c91e168.jpg/v1/fill/w_1905,h_460,al_c,q_85,enc_avif,quality_auto/93507cc36ceb4f698334c53a1c91e168.jpg",
    hero_image: "https://static.wixstatic.com/media/7a755a_6fa9eef2c68446fc89339a6fec03aa60~mv2.jpg/v1/fill/w_578,h_507,al_c,q_80,enc_avif,quality_auto/7a755a_6fa9eef2c68446fc89339a6fec03aa60~mv2.jpg",
    intro:
      "Trust Knight Insurance Solutions to set up protection from all the risks your business faces. There is an insurance option for every business, no matter the industry or size. Our clients range from home businesses to restaurants, to wholesalers. Guard yourself, your assets, and your personal finances against business loss with an airtight policy that has been created specifically for you.",
    coverage_heading: "We're experts in business insurance policies, including:",
    coverage: [
      "General Liability",
      "Commercial Property",
      "Commercial Bonds",
      "Business Auto",
      "Contractor's Packages",
      "Key Person Policy",
      "Errors and Omissions",
    ],
  },
  specialty: {
    slug: "specialty",
    title: "Specialty & Other",
    eyebrow: "For the things that make life yours",
    banner: null,
    hero_image: null,
    intro:
      "From weekend rides to your most treasured heirlooms, your specialty assets deserve coverage built around how you actually use them. Knight Insurance Solutions partners with carriers that specialize in non-standard policies — so motorcycles, boats, RVs, and prized collections get the same diligent protection as your home and auto.",
    coverage_heading:
      "We write specialty policies tailored to the toys, tools, and treasures you've worked hard for, including:",
    coverage: [
      "Motorcycle Insurance",
      "Watercraft & Boat Insurance",
      "RV & Motorhome Insurance",
      "Jewelry & Fine Art Coverage",
      "Classic & Collector Vehicles",
      "ATV / Off-Road / Snowmobile",
      "Scheduled Personal Property",
    ],
    discounts_heading:
      "Bundling specialty coverage with your auto or home policy unlocks meaningful savings — for example:",
    discounts: [
      "Multi-Vehicle Discount",
      "Multi-Policy Bundle",
      "Safe Rider / Boater Course",
      "Stored / Seasonal Use",
    ],
  },
  motorcycle: {
    slug: "motorcycle",
    title: "Motorcycle Insurance",
    eyebrow: "Two wheels, full coverage",
    banner: "https://images.unsplash.com/photo-1558981852-426c6c22a060?fm=jpg&q=80&w=1905&h=460&fit=crop",
    hero_image: "https://images.unsplash.com/photo-1568772585407-9361f9bf3a87?fm=jpg&q=80&w=900&auto=format&fit=crop",
    intro:
      "Whether you ride a sport bike, a cruiser, a touring rig, or a vintage build, Knight Insurance Solutions matches your motorcycle policy to the way you actually ride. We work with carriers that specialize in two-wheel coverage — so you get the right protection without paying for what you don't need.",
    coverage_heading:
      "Motorcycle policies we routinely tailor for our clients include:",
    coverage: [
      "Bodily Injury & Property Damage Liability",
      "Collision & Comprehensive",
      "Uninsured / Underinsured Motorist",
      "Medical Payments",
      "Custom Parts & Equipment (Accessories)",
      "Roadside Assistance & Trip Interruption",
      "Total Loss Replacement (new bikes)",
      "Optional Equipment & Riding Gear",
    ],
    discounts_heading:
      "Riders are eligible for a number of stacking discounts, including:",
    discounts: [
      "Multi-Vehicle Bundle (auto + bike)",
      "Safe Rider / MSF Course",
      "Anti-Theft Device",
      "Stored / Seasonal Use",
    ],
  },
  rv: {
    slug: "rv",
    title: "RV & Motorhome Insurance",
    eyebrow: "Home on wheels, properly protected",
    banner: "https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?fm=jpg&q=80&w=1905&h=460&fit=crop",
    hero_image: "https://images.unsplash.com/photo-1523987355523-c7b5b0dd90a7?fm=jpg&q=80&w=900&auto=format&fit=crop",
    intro:
      "Class A, B, or C motorhome, fifth-wheel, travel trailer, or pop-up — a great RV policy goes well beyond auto liability. Knight Insurance Solutions structures coverage around how you actually use your rig, including full-time living, contents, vacation liability, and emergency expenses on the road.",
    coverage_heading:
      "Common RV coverages we line up for our clients include:",
    coverage: [
      "Liability (Bodily Injury & Property Damage)",
      "Comprehensive & Collision",
      "Personal Effects & Contents",
      "Full-Timer's Liability",
      "Vacation / Campsite Liability",
      "Emergency Expense (lodging & transport)",
      "Roadside Assistance for RVs",
      "Total Loss Replacement & Purchase Price",
    ],
    discounts_heading:
      "RV policies often qualify for multiple stacking discounts:",
    discounts: [
      "Multi-Policy Bundle (auto + home + RV)",
      "Original Owner Discount",
      "Storage / Limited Use",
      "Safety Course Completion",
    ],
  },
  watercraft: {
    slug: "watercraft",
    title: "Watercraft & Boat Insurance",
    eyebrow: "Built for time on the water",
    banner: "https://images.unsplash.com/photo-1502780402662-acc01917738e?fm=jpg&q=80&w=1905&h=460&fit=crop",
    hero_image: "https://images.unsplash.com/photo-1567899378494-47b22a2ae96a?fm=jpg&q=80&w=900&auto=format&fit=crop",
    intro:
      "From bass boats and pontoons to ski boats, sailboats, and yachts, Knight Insurance Solutions tailors watercraft policies to how — and where — you actually boat. We work with marine specialists that handle everything from agreed-value hull coverage to on-water salvage and fuel spill liability.",
    coverage_heading:
      "Watercraft policies we routinely tailor for our clients include:",
    coverage: [
      "Hull Coverage (Agreed Value Available)",
      "Liability for Bodily Injury & Property Damage",
      "Medical Payments",
      "Uninsured Boater",
      "Personal Effects & Fishing Equipment",
      "On-Water Towing & Assistance",
      "Salvage & Wreck Removal",
      "Fuel Spill Liability",
    ],
    discounts_heading:
      "Most boaters qualify for several stacking discounts:",
    discounts: [
      "Multi-Policy Bundle",
      "Boater Safety Course",
      "Lay-Up / Seasonal Use",
      "Original Owner / Diesel Engine",
    ],
  },
  jewelry: {
    slug: "jewelry",
    title: "Jewelry & Fine Art Insurance",
    eyebrow: "Heirlooms, art, and the irreplaceable",
    banner: "https://images.unsplash.com/photo-1605100804763-247f67b3557e?fm=jpg&q=80&w=1905&h=460&fit=crop",
    hero_image: "https://images.unsplash.com/photo-1515562141207-7a88fb7ce338?fm=jpg&q=80&w=900&auto=format&fit=crop",
    intro:
      "Standard homeowners coverage caps payouts on jewelry and fine art at a fraction of true value. Knight Insurance Solutions writes scheduled personal property and inland marine policies so engagement rings, watches, paintings, wine, antiques, and collections are insured for their full appraised worth — and protected against losses a homeowners policy simply won't cover.",
    coverage_heading:
      "Coverages we routinely arrange for valuables include:",
    coverage: [
      "Scheduled Jewelry & Watches",
      "Fine Art & Collectibles",
      "Wine Collections",
      "Antiques & Heirlooms",
      "Worldwide Coverage (in transit)",
      "Mysterious Disappearance",
      "No Deductible Options",
      "Newly Acquired Items (auto-cover)",
    ],
    discounts_heading:
      "Carriers reward proper care of valuables with discounts including:",
    discounts: [
      "Home Safe / Vault Storage",
      "Central-Station Alarm",
      "Bundled with Homeowners",
      "Updated Appraisals",
    ],
  },
};

export const SERVICE_ROUTES = {
  auto: "/auto-insurance",
  home: "/homeowners-insurance",
  life: "/life-insurance",
  health: "/health-insurance",
  business: "/business-insurance",
  specialty: "/specialty-insurance",
  motorcycle: "/motorcycle-insurance",
  rv: "/rv-insurance",
  watercraft: "/watercraft-insurance",
  jewelry: "/jewelry-fine-art-insurance",
};
